import * as Yup from 'yup'
export const authSchema = Yup.object({
    username: Yup.string()
    .required('INPUT.VALIDATION.USERNAME.LOGIN'),
    password:Yup.string().required('INPUT.VALIDATION.PASSWORD.LOGIN').min(8, 'INPUT.VALIDATION.WRONG_CREDENTIALS'),
})